import styled from 'styled-components';

export default styled.div`
  border-radius: 10px;
  background-color: #3b4251;
  padding: 10px;
  text-align: center;
`;
